import React from 'react'
import PropTypes from 'prop-types'
import NoIndex from '../NoIndex'
import DeliveryList from './DeliveryList'

import GenericSelect from '../GenericSelect'
import styles from './delivery.module.scss'
import styled from 'styled-components'

class ProductDelivery extends React.Component {
  state = {
    value:
      this.props.locationData.current && this.props.locationData.current.fiasId,
    deliveries: `Загружаем...`,
  }
  _isMounted = false
  componentDidMount() {
    this._isMounted = true
    this.onChange(this.state.value)
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.value) return

    if (prevProps.locationData.current) {
      this.getDeliveryMethods(prevProps.locationData.current.fiasId)

      this.setState({
        value: prevProps.locationData.current.fiasId,
      })
    }
  }
  componentWillUnmount() {
    this._isMounted = false
  }
  onChange = (value) => {
    this.setState({
      value: value,
      deliveries: `Загружаем...`,
    })
    this.getDeliveryMethods(value)
  }
  getDeliveryMethods(value) {
    const { name, fullName } =
      this.props.locationData.majorCities[value] ||
      this.props.locationData.current
    fetch(
      `/checkout_provider/fetch_delivery_methods.json?settlement_id=${value}&settlement_name=${encodeURIComponent(
        name
      )}&settlement_full_name=${encodeURIComponent(fullName)}`
    )
      .then((res) => {
        if (res.status >= 400) {
          throw new Error(`Error`)
        }
        return res.json()
      })
      .then((response) => {
        if (Object.keys(response).length) {
          const { express, lightning, postamat, pvz } = response
          if (this._isMounted) {
            this.setState({
              deliveries: {
                express,
                lightning,
                pickup: this.unionJSON(postamat, pvz),
              },
            })
          }
        } else {
          if (this._isMounted) {
            this.setState({
              deliveries: `Нет доставки в этот город`,
            })
          }
        }
      })
      .catch(() => {
        if (this._isMounted) {
          this.setState({
            deliveries: `Ошибка`,
          })
        }
      })
  }
  unionJSON(json1, json2) {
    let resultJSON = {}
    if (json1 && json2) {
      for (let key in json1) {
        if (Array.isArray(json1[key])) {
          resultJSON[key] = json1[key].concat(json2[key])
        } else {
          resultJSON[key] = json1[key]
        }
      }
    } else if (json1) {
      resultJSON = json1
    } else if (json2) {
      resultJSON = json2
    }
    return resultJSON
  }
  render() {
    const { deliveries, value: cityFiasId } = this.state

    if (!cityFiasId) return null

    const {
      title,
      locationData: { majorCities, current },
      withoutTitle,
      onPlatform,
    } = this.props
    const isMoscow =
      majorCities[cityFiasId] && majorCities[cityFiasId].name === `Москва`
    return (
      <NoIndex>
        <div className={styles.root}>
          <h2 className={styles.title}>
            {!withoutTitle && title}
            <div className={styles.select}>
              <StyledGenericSelect
                value={this.state.value}
                options={[
                  {
                    value: current.fiasId,
                    label: current.name,
                  },
                  ...Object.keys(majorCities)
                    .filter((key) => key !== current.fiasId)
                    .map((key) => ({
                      value: key,
                      label: majorCities[key].name,
                    })),
                ]}
                onChange={this.onChange}
              />
            </div>
          </h2>
          <div className={styles.content}>
            <DeliveryList items={deliveries} isMoscow={isMoscow} />
          </div>
          <Container columns="6fr 6fr" className={styles.footer}>
            {onPlatform !== `vtb` && (
              <div className={styles.payment}>
                <h3>Способы оплаты</h3>
                <ul>
                  <li>— Наличными при получении</li>
                  <li>— Моментально на сайте</li>
                  <li>— Переводом на счет организации</li>
                </ul>
              </div>
            )}
            <div>
              <h3>Условия возврата</h3>
              <p>
                По любой причине переделаем заказ и сделаем ускоренную доставку
                или вернем деньги. Без лишних вопросов и бумажек.
              </p>
            </div>
          </Container>
        </div>
      </NoIndex>
    )
  }
}

const StyledGenericSelect = styled(GenericSelect)`
  div:nth-child(2) {
    width: fit-content !important;
  }
`

const Container = styled.div`
  display: grid;
  grid-template-columns: ${(p) => p.columns};
`

ProductDelivery.propTypes = {
  title: PropTypes.string,
  locationData: PropTypes.object,
  withoutTitle: PropTypes.bool,
  onPlatform: PropTypes.string,
}

export default ProductDelivery
